import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import SeeAllLink from 'components/SeeAllLink';
import _isEmpty from 'lodash/isEmpty';
import { makeSelectAuth } from 'containers/Auth/selectors';
import Carousel from 'components/Carousel';
import withSizes from 'react-sizes';
import { trackFavoriteAction } from 'containers/Favorites/utils';
import CarouselContainer from 'components/Carousel/CarouselContainer';
import {
  getSavedAssessments,
  getTakenAssessments,
  saveAssessment,
} from 'containers/Assessments/actions';
import LoadingSkeleton from 'components/LoadingSkeleton';
import {
  makeSelectSavedAssessments,
  makeSelectTakenAssessments,
} from 'containers/Assessments/selectors';
import AssessmentsItem from 'containers/Assessments/AssessmentsItem';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import {
  isAssessmentSaved,
  isAssessmentTaken,
} from 'containers/Assessments/utils';
import AppContainer from 'components/AppContainer';
import { getHomeAssessments } from '../actions';
import { makeSelectAssessments, makeSelectProcessing } from '../selectors';

const styles = () => ({
  itemsWrapper: {
    '& > div': {
      maxWidth: '100%',
    },
  },
  viewMore: {
    display: 'flex',
    justifyContent: 'center',
  },
});

class AssessmentsLists extends React.Component {
  componentDidMount() {
    this.checkUserIdAndRequest(this.props);
  }

  UNSAFE_componentWillUpdate(nextProps) {
    this.checkUserIdAndRequest(nextProps);
  }

  checkUserIdAndRequest = props => {
    if (props.auth.isLoaded && !this.assessmentsRequested) {
      this.assessmentsRequested = true;
      props.getHomeAssessments({ limit: props.allMobileSize ? 6 : 12 });
      props.getSavedAssessments();
      props.getTakenAssessments();
    }
  };

  saveAssessment = (assessmentID, slug, name, time, callToAction, saved) => {
    const { auth, savedAssessments } = this.props;

    let nodeID;
    if (saved)
      [{ nodeID }] = savedAssessments.filter(el => el.sys.id === assessmentID);

    const data = {
      nodeID,
      assessment: {
        assessmentID,
        slug,
        name,
        callToAction,
        time,
      },
      save: !saved,
    };

    trackFavoriteAction(
      'Card Click',
      {
        page: 'Home Page',
        type: 'Assessments',
        resourceID: assessmentID,
        slug,
        name,
      },
      auth,
      saved,
    );

    this.props.saveAssessment(data);
  };

  render() {
    const {
      processing,
      assessments,
      savedAssessments,
      takenAssessments,
      classes,
      isMobile,
    } = this.props;
    const { data } = assessments;
    const showSkeleton = _isEmpty(data) || processing;
    const customProps = isMobile ? { centerMode: true } : null;
    return (
      <AppContainer topPadding={isMobile} noPadding>
        <Grid container spacing={2}>
          <CarouselContainer>
            <Carousel customProps={customProps}>
              {showSkeleton &&
                Array.from(new Array(4)).map((_, index) => (
                  <LoadingSkeleton key={index} />
                ))}
              {!showSkeleton &&
                data.map(item => {
                  const saved = isAssessmentSaved(savedAssessments, {
                    id: item.objectID,
                    ...item,
                  });
                  const taken = isAssessmentTaken(takenAssessments, {
                    id: item.objectID,
                    ...item,
                  });
                  return (
                    <LazyLoadComponent>
                      <AssessmentsItem
                        carousel
                        key={item.slug}
                        item={{
                          fields: { ...item },
                          sys: { id: item.objectID },
                        }}
                        saved={saved}
                        taken={taken}
                        save={this.saveAssessment}
                      />
                    </LazyLoadComponent>
                  );
                })}
            </Carousel>
          </CarouselContainer>
          <Hidden smUp>
            <Grid item xs={12} className={classes.viewMore}>
              <SeeAllLink link="assessments" isMobile align="center" bordered />
            </Grid>
          </Hidden>
        </Grid>
      </AppContainer>
    );
  }
}

AssessmentsLists.propTypes = {
  assessments: PropTypes.object,
  auth: PropTypes.object,
  processing: PropTypes.bool,
  saveAssessment: PropTypes.func,
  savedAssessments: PropTypes.array,
  takenAssessments: PropTypes.array,
  classes: PropTypes.object,
  isMobile: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  auth: makeSelectAuth(),
  processing: makeSelectProcessing(),
  assessments: makeSelectAssessments(),
  savedAssessments: makeSelectSavedAssessments(),
  takenAssessments: makeSelectTakenAssessments(),
});

function mapDispatchToProps(dispatch, { location }) {
  return {
    getHomeAssessments: payload => dispatch(getHomeAssessments(payload)),
    getSavedAssessments: () => dispatch(getSavedAssessments()),
    getTakenAssessments: () => dispatch(getTakenAssessments()),
    saveAssessment: payload =>
      dispatch(saveAssessment({ ...payload, location })),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const mapSizesToProps = ({ width }) => ({
  isMobile: width <= 600 && width > 470,
  allMobileSize: width < 600,
});

export default compose(
  withConnect,
  withStyles(styles),
  withSizes(mapSizesToProps),
)(AssessmentsLists);
